module.exports = __webpack_public_path__ + "static/media/search2.afc8a3f6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/search2.svg
// module id = 342
// module chunks = 0